import { useState, useCallback, useRef, useEffect } from "react"
import DashboardService from "./../../../../Service/API/Dashboard/DashboardService"
import { QrisPanel } from "./PickerComponent/QrisPanel"
import { VAPanel } from "./PickerComponent/VaPanel"


const CollapsePanel = ({ open, children }) => {
  const ref = useRef(null)
  const [height, setHeight] = useState(0)

  useEffect(() => {
    if (ref.current) setHeight(open ? ref.current.scrollHeight : 0)
  }, [open, children])

  return (
    <div
      style={{
        overflow: "hidden",
        maxHeight: height,
        transition: "max-height 0.28s cubic-bezier(0.4,0,0.2,1)",
      }}
    >
      <div ref={ref}>{children}</div>
    </div>
  )
}

export const PaymentMethodPicker = ({ data }) => {
  const qrisLogo = 'https://vectorseek.com/wp-content/uploads/2023/09/Quick-Response-Code-Indonesia-Standard-QRIS-Logo-Vector.svg-.png'
  const profile = data?.profile ?? {}
  const currPeriod = data?.currentPeriod ?? {}

  // console.log({
  //   profile,
  //   currPeriod
  // })
  const isPsb = currPeriod.type === "psb"
  const trxId = currPeriod.id ?? currPeriod.trx_id

  const basePrice = Number(currPeriod.price ?? 0)

  const total = Number(currPeriod.grand_total ?? currPeriod.final_price ?? basePrice)
  const paymentLogoStyles = {
    width: 50,
    height: 34,
    objectFit: "contain",
    background: "#fff",
    padding: 2
  }

  const allBanks = [
    // {
    //   key: "bni",
    //   label: isPsb ? "BNI" : "BNI",
    //   va: isPsb ? currPeriod.virtual_account : currPeriod.bniVa,
    //   fee: profile.bniAdminFee,
    //   active: false,
    //   logo: "https://d2v6npc8wmnkqk.cloudfront.net/storage/6613/conversions/BNI-small.webp"
    // },
    {
      key: "bca",
      label: "BCA",
      va: isPsb ? currPeriod.virtual_account_bca : profile.bcaInvoiceVa,
      fee: profile.bcaAdminFee,
      active: false,
      logo: "https://www.bca.co.id/-/media/Feature/Header/Header-Logo/logo-bca.svg"
    },
    {
      key: "bri",
      label: "BRI",
      va: isPsb ? currPeriod.virtual_account_bri : profile.briInvoiceVa,
      fee: profile.briAdminFee,
      active: false,
      logo: "https://www.ir-bri.com/bbri_assets/vendor/img/bri-logo.png"
    },
    {
      key: "mandiri",
      label: "Mandiri",
      va: isPsb ? currPeriod.virtual_account_mandiri : profile.mandiriInvoiceVa,
      fee: profile.mandiriAdminFee,
      active: false,
      logo: "https://www.bankmandiri.co.id/image/layout_set_logo?img_id=31567"
    },
    {
      key: "cimb",
      label: "CIMB",
      va: isPsb ? currPeriod.virtual_account_cimb : profile.cimbInvoiceVa,
      fee: profile.cimbAdminFee,
      active: false,
      logo: "https://www.cimb.com/content/dam/cimb/personal/images/global/cimb-general.svg"
    },
    {
      key: "bsi",
      label: "BSI",
      va: isPsb ? currPeriod.virtual_account_bsi : profile.bsiInvoiceVa,
      fee: profile.bsiAdminFee,
      active: false,
      logo: "https://www.bankbsi.co.id/img/logo.png"
    },
    {
      key: "bnc",
      label: "BNC",
      va: isPsb ? currPeriod.virtual_account_bnc : profile.bncInvoiceVa,
      fee: profile.bncAdminFee,
      active: false,
      logo: "https://www-cms.bankneo.co.id/storage/photos/1/logo/logo_bnc.png"
    },
    {
      key: "btn",
      label: "BTN",
      va: isPsb ? currPeriod.virtual_account_bnc : profile.btnInvoiceVa,
      fee: profile.btnAdminFee,
      active: false,
      logo: "https://www.btn.co.id/-/media/Images/Corporate/Icon/Logo-BTN.png?h=30&w=75&hash=482544389654CC413EA54D404409BF15"
    },
    {
      key: "permata",
      label: "Permata",
      va: isPsb ? currPeriod.virtual_account_permata : profile.permataInvoiceVa,
      fee: profile.permataAdminFee,
      active: false,
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/ff/Permata_Bank_%282024%29.svg/500px-Permata_Bank_%282024%29.svg.png"
    },
    {
      key: "danamon",
      label: "Danamon",
      va: isPsb ? currPeriod.virtual_account_danamon : profile.danamonInvoiceVa,
      fee: profile.danamonAdminFee,
      active: false,
      logo: "https://www.danamon.co.id/-/media/Project/Danamon/DCWCOID/v1/Header/Logo/Logo-Danamon-Default-v1.svg?h=29&w=28"
    },
    {
      key: "bss",
      label: "BSS",
      va: isPsb ? currPeriod.virtual_account_bss : profile.bssInvoiceVa,
      fee: profile.bssAdminFee,
      active: false,
      logo: "https://statics.banksampoerna.com/assets/images/logo.png"
    }
  ].filter(b => b.va)

  const [openKey, setOpenKey] = useState(null)
  const [copied, setCopied] = useState(null)
  const [qrisState, setQrisState] = useState({ status: "idle", qrContent: null, validityPeriod: null, error: null })

  const toggle = useCallback((key) => {
    setOpenKey(prev => prev === key ? null : key)
  }, [])

  const handleCopy = useCallback((val, key) => {
    navigator.clipboard.writeText(val.replace(/\s/g, "")).catch(() => {})
    setCopied(key)
    setTimeout(() => setCopied(null), 2000)
  }, [])

  const handleGenerateQris = useCallback(async () => {
    setQrisState({ status: "loading", qrContent: null, error: null })
    try {
      const dashboardService  = new DashboardService()
      const responses = await dashboardService.postQris(trxId)
      const data = responses?.data ?? {}
      const info = data.additionalInfo ?? {}
      setQrisState({ status: "done", qrContent: data?.qrContent, validityPeriod: info?.validityPeriod, error: null })
    } catch (error) {
      console.log(error.message)
      setQrisState({ status: "error", qrContent: null, validityPeriod: null, error: "Gagal membuat QR Code. Silakan coba lagi." })
    }
  }, [trxId])

  const handleFetchQris = useCallback(async () => {
    setQrisState({ status: "loading", qrContent: null, validityPeriod: null, error: null })
    try {
      const dashboardService  = new DashboardService()
      const responses = await dashboardService.getQrisState(trxId)
      const data = responses?.data ?? {}
      const info = data.additionalInfo ?? {}
      if (!Object.keys(data).length) {
        console.log('Set idle', data)
        setQrisState({ status: "idle", qrContent: null, validityPeriod: null, error: null })
        return
      }
      console.log('Set done', data)
      setQrisState({ status: "done", qrContent: data?.qrContent, validityPeriod: info?.validityPeriod, error: null })
    } catch (error) {
      console.log(error.message)
      // setQrisState({ status: "done" })
      setQrisState({ status: "idle", qrContent: null, validityPeriod: null, error: null })
    }
  }, [trxId])

  useEffect(() => {
    handleFetchQris()
  }, [])
  const handleRefreshQris = useCallback(() => {
    setQrisState({ status: "idle", qrContent: null, validityPeriod: null, error: null })
    handleGenerateQris()
  }, [handleGenerateQris])

  const chevronStyle = (key) => ({
    fontSize: 12,
    transition: "transform 0.2s",
    transform: openKey === key ? "rotate(180deg)" : "rotate(0deg)",
    flexShrink: 0,
  })

  const triggerStyle = {
    cursor: "pointer",
    background: "none",
    border: "none",
    width: "100%",
  }

  return (
    <div className="card">
      <div className="card-header mb-0">
        <span className="fw-semibold" style={{ fontSize: 14 }}>Metode Pembayaran</span>
      </div>

      <div className="card-body p-0">
        {/* QRIS */}
        {
          !profile?.qrisEnabled
          ? <></>
          : (<>
            <div>
              <button
                style={triggerStyle}
                className="d-flex align-items-center gap-2 px-3 py-2"
                onClick={() => toggle("qris")}
                aria-expanded={openKey === "qris"}
              >
                <div
                  className="flex-shrink-0 rounded border d-flex align-items-center justify-content-center bg-body-secondary"
                  style={{ width: 50, height: 34 }}
                >
                  <img
                    src={qrisLogo}
                    alt={'Qris'}
                    className="flex-shrink-0 rounded border"
                    style={paymentLogoStyles}
                    onError={e => { e.target.style.display = "none" }}
                  />
                </div>
                <div className="flex-grow-1 text-start overflow-hidden">
                  <div className="fw-medium" style={{ fontSize: 13 }}>QRIS</div>
                  <div className="text-muted" style={{ fontSize: 11 }}>GoPay · OVO · Dana · Semua Bank</div>
                </div>
                <i className="fa fa-chevron-down text-muted" style={chevronStyle("qris")} aria-hidden="true" />
              </button>

              <CollapsePanel open={openKey === "qris"}>
                <QrisPanel
                  currPeriod={currPeriod}
                  total={total}
                  qrisState={qrisState}
                  profile={profile}
                  onGenerate={handleGenerateQris}
                  onRefresh={handleRefreshQris}
                />
              </CollapsePanel>
            </div>
          </>)
        }

        {/* VA Banks */}
        {allBanks.map(bank => (
          <div key={bank.key} className="border-bottom">
            <button
              style={triggerStyle}
              className="d-flex align-items-center gap-2 px-3 py-2"
              onClick={() => toggle(bank.key)}
              aria-expanded={openKey === bank.key}
            >
              <img
                src={bank.logo}
                alt={bank.label}
                className="flex-shrink-0 rounded border"
                style={paymentLogoStyles}
                onError={e => { e.target.style.display = "none" }}
              />
              <div className="flex-grow-1 text-start overflow-hidden">
                <div className="d-flex align-items-center gap-1">
                  <span className="fw-medium" style={{ fontSize: 13 }}>{bank.label}</span>
                  {bank.active && (
                    <span className="badge bg-primary ms-1" style={{ fontSize: 10 }}>Utama</span>
                  )}
                </div>
                <div className="text-muted" style={{ fontSize: 11 }}>Virtual Account</div>
              </div>
              <i className="fa fa-chevron-down text-muted" style={chevronStyle(bank.key)} aria-hidden="true" />
            </button>

            <CollapsePanel open={openKey === bank.key}>
              <VAPanel
                bank={bank}
                currPeriod={currPeriod}
                fees={bank.fee}
                total={total}
                copied={copied}
                onCopy={handleCopy}
              />
            </CollapsePanel>
          </div>
        ))}
      </div>
    </div>
  )
}